import {NameGenerator} from '@domain/custom-settings/name-generator';
import {FontFamily} from '@domain/fonts/font-family.enum';
import {FontStyle} from '@domain/fonts/font-style.enum';
import {FontWeight} from '@domain/fonts/font-weight.enum';
import {AssertionUtils} from '@vdw/angular-component-library';

export class PathLabelSettings {
  private _nameGenerator: NameGenerator;
  private _technicalHeightInPicks: number;
  private _fontFamily: FontFamily;
  private _fontWeight: FontWeight;
  private _fontStyle: FontStyle;
  private _heightInMM: number;

  public constructor(nameGenerator: NameGenerator, technicalHeightInPicks: number, fontFamily: FontFamily, fontWeight: FontWeight, fontStyle: FontStyle, heightInMM: number) {
    this._nameGenerator = nameGenerator;
    this._technicalHeightInPicks = technicalHeightInPicks;
    this._fontFamily = fontFamily;
    this._fontWeight = fontWeight;
    this._fontStyle = fontStyle;
    this._heightInMM = heightInMM;
  }

  public get nameGenerator(): NameGenerator {
    return this._nameGenerator;
  }

  public set nameGenerator(value: NameGenerator) {
    this._nameGenerator = value;
  }

  public get technicalHeightInPicks(): number {
    return this._technicalHeightInPicks;
  }

  public set technicalHeightInPicks(value: number) {
    this._technicalHeightInPicks = value;
  }

  public get fontFamily(): FontFamily {
    return this._fontFamily;
  }

  public set fontFamily(value: FontFamily) {
    this._fontFamily = value;
  }

  public get fontWeight(): FontWeight {
    return this._fontWeight;
  }

  public set fontWeight(value: FontWeight) {
    this._fontWeight = value;
  }

  public get fontStyle(): FontStyle {
    return this._fontStyle;
  }

  public set fontStyle(value: FontStyle) {
    this._fontStyle = value;
  }

  public get heightInMM(): number {
    return this._heightInMM;
  }

  public set heightInMM(value: number) {
    this._heightInMM = value;
  }

  public toJSON(): JSON {
    return {
      nameGenerator: this._nameGenerator.toJSON(),
      technicalHeightInPicks: this._technicalHeightInPicks,
      fontFamily: FontFamily[this._fontFamily],
      fontWeight: FontWeight[this._fontWeight],
      fontStyle: FontStyle[this._fontStyle],
      heightInMM: this._heightInMM
    } as any as JSON;
  }

  public static fromJSON(json: any): PathLabelSettings {
    return new PathLabelSettings(
      AssertionUtils.isNullOrUndefined(json.nameGenerator) ? null : NameGenerator.fromJSON(json.nameGenerator),
      json.technicalHeightInPicks,
      FontFamily[json.fontFamily as string],
      FontWeight[json.fontWeight as string],
      FontStyle[json.fontStyle as string],
      json.heightInMM
    );
  }
}
